import React, { PropsWithChildren } from "react";
import styled from "styled-components";
import tw from "twin.macro";

const Content = styled.div`
  ${tw`relative text-white bg-darkblue-gradient my-[50px] md:my-[80px] rounded-[30px]`}
`;

const TestimonialBoxDark: React.FunctionComponent<PropsWithChildren> = ({
  children,
}) => <Content>{children}</Content>;

export default TestimonialBoxDark;
